export var AuthorizationType;
(function (AuthorizationType) {
    AuthorizationType["ALLOWANCE"] = "allowance";
    AuthorizationType["APPROVAL"] = "approval";
})(AuthorizationType || (AuthorizationType = {}));
export var AuthorizationAction;
(function (AuthorizationAction) {
    AuthorizationAction["GRANT"] = "grant";
    AuthorizationAction["REVOKE"] = "revoke";
})(AuthorizationAction || (AuthorizationAction = {}));
//# sourceMappingURL=types.js.map